import type {
  CreateNote,
  NoteBundle,
  NoteSearch,
  NoteUpdate,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class NotesApi {
  public async getNotes(params: NoteSearch): Promise<NoteBundle> {
    const result = await trpcClient.patient.getNotes.query(params);
    const { link, notes, pins } = result;

    return {
      link,
      notes,
      pins,
    };
  }

  public async updateNote(params: NoteUpdate) {
    await trpcClient.patient.noteUpdate.mutate({
      ...params,
    });
  }

  public async createNote(body: CreateNote) {
    await trpcClient.patient.createNote.mutate(body);
  }

  public async pinNote(params: NoteUpdate) {
    await trpcClient.patient.noteUpdate.mutate({
      ...params,
    });
  }
}
